import { render, staticRenderFns } from "./DashboardPerformanceStatsPie.vue?vue&type=template&id=44d5ba5f"
import script from "./DashboardPerformanceStatsPie.vue?vue&type=script&lang=js"
export * from "./DashboardPerformanceStatsPie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.25_cache-loader@4.1.0_webpack@4.47.0__css-load_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports